<template>
<drawer-layaout>
    <main>
            <div class="demo-container">
                <h1>Progress/Stepper</h1>
                <VueLive
                :components="registeredStepper"
                :code=
'`<template>
    <div class="stepper-cont-demo flex-disp">
        <Stepper :steps="items">
            <template #stepper-content>
                <v-card
              class="mb-12"
              height="200px"
            >
            <p>This is one of the steps in this process.
            <br>
            Click continue to proceed to the next step.
            <br>
            You can also click on the progress icon for the item you wish to visit.</p>
            </v-card>
            </template>
        </Stepper>
    </div>
</template>
<script>
    export default  {
        data() {
            return {
                items: [{value:1,label:"inicio"},{value:2,label:"medio"},{value:3, label:"fin"}],
            }
        }
    }
</script>`'
                />
                <h1>SearchBar</h1>
                <VueLive
                :components="registeredSearch"
                :code=
'`<template>
    <div class="searches flex-disp">
        <div class="btns-cont">
            <SearchBar @change="(e)=>logger(e)"/>
            <span>{{data}}</span>
        </div>
        <div class="btns-cont">
            <SearchBar @search="(e)=>{searcher(e)}"/>
            <span>{{search}}</span>
        </div>
    </div>

</template>
<script>
    export default  {
        data() {
            return {
                data:"",
                search:"",
            }
        },
        methods:{
            logger(e){
                this.data=e;
            },
            searcher(e){
                this.search=e;
            },
        }
    }
</script>`
'
                />
                <h1>Tabs</h1>
                <VueLive

                    :components ="registeredTabs"
                    :code=
'`<template>
    <div class="tabs-content">
        <div>

            <Tabs :items="items" />

        </div>
    </div>
</template>
<script>
    export default  {
        data() {
            return {
                items: ["item1" , "Item2", "Item3", "Item4", "item5", "item6", "item7" , "Item8", "Item9", "Item10", "item11", "item12"],
            }
        }
    }
</script>`'
                />

              <h1>Notifications</h1>
              <VueLive
                :requires="{vuex: require('vuex')}"
                :components ="registeredNotif"
                :code=
'`<template>
    <div class="flex-disp">
        <div class="button-display btns-cont">
            <v-btn class="v-btn--primary"  @click="togglewarning"> toggle Warning</v-btn>
            <v-btn class="v-btn--primary"  @click="toggleerror"> toggle Error</v-btn>
            <v-btn class="v-btn--primary"  @click="toggleinfo"> toggle Info</v-btn>
            <v-btn class="v-btn--primary"  @click="togglesuccess"> toggle Success</v-btn>
        </div>
    </div>
</template>
<script>
    import { mapMutations } from "vuex";
    export default {
        methods:{
// in the project we use a single implementation of this component
// we call the notifications by using this method:
          ...mapMutations({
            setNotification: "setNotification"
          }),
           togglewarning(){
            this.setNotification({
                title: "this is a notification",
                msg: "it is a warning",
                filled: false,
                warning: true,  //warning/info/success/error
                active: true,
            })
          },
          toggleerror(){
            this.setNotification({
                title: "this is a notification",
                msg: "it displays an error",
                filled: false,
                error: true,  //warning/info/success/error
                active: true,
            })
          },
          toggleinfo(){
            this.setNotification({
                title: "this is a notification",
                msg: "it has information",
                filled: false,
                info: true,  //warning/info/success/error
                active: true,
            })
          },
          togglesuccess(){
            this.setNotification({
                title: "this is a notification",
                msg: "it notifies you have succeeded",
                filled: false,
                success: true,  //warning/info/success/error
                active: true,
            })
          },
        },
// the Notification is located in the navigation drawer
// so it is displayed everywhere you code B)
    }
</script>`'
              />
              <h1>buttons</h1>
              <VueLive
              :code=
"`<template>
    <div class='flex-disp'>
        <div class='button-display btns-cont'>
            <v-btn class='v-btn--primary'>Button</v-btn>
            <v-btn class='v-btn--secondary'>Button</v-btn>
            <v-btn class='v-btn--red'>Button</v-btn>
            <v-btn class='v-btn--primary' disabled>Button</v-btn>
        </div>
    </div>
</template>`"
              />
              <h1>icon buttons</h1>
              <VueLive
              :code=
"`<template>
    <div class='flex-disp'>
        <div class='button-display btns-cont'>
            <v-btn class='btn-icon--primary btn-icon'><v-icon>mdi-check</v-icon></v-btn>
            <v-btn class='btn-icon--secondary btn-icon'><v-icon>mdi-eye</v-icon></v-btn>
            <v-btn class='btn-icon--warning btn-icon'><v-icon>mdi-exclamation</v-icon></v-btn>
            <v-btn class='btn-icon--delete btn-icon'><v-icon>mdi-trash-can</v-icon></v-btn>
            <v-btn class='btn-icon' disabled><v-icon>mdi-trash-can</v-icon></v-btn>
        </div>
    </div>
</template>`"
              />
              <h1>Form</h1>
              <h2>Text Field</h2>
              <VueLive
              :code=
"`<template>
    <div class='flex-disp'>
        <div>
            <v-text-field messages='Un mensaje' class='input-text input-text--text-field' outlined dense></v-text-field>
            <h5>disabled</h5>
            <v-text-field messages='Este campo esta desactivado' class='input-text input-text--text-field' disabled outlined dense></v-text-field>
            <h5>Error</h5>
            <v-text-field messages='Este campo esta en estado de error' error class='input-text input-text--text-field' outlined dense></v-text-field>
            <h5>Success</h5>
            <v-text-field  messages='Este campo esta en estado de exito' class='input-text input-text--text-field' success outlined dense></v-text-field>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                someval: false,
                radioGroup: [true],
            }
        },
    }
</script>`
"/>
            <h2>Text Area</h2>
              <VueLive
              :code=
"`<template>
    <div class='flex-disp'>
        <div class ='t-area btns-cont'>
            <v-textarea class='input-text'  messages='Un mensaje' outlined dense></v-textarea>
            <h5>disabled</h5>
            <v-textarea class='input-text' disabled messages='Este campo esta desactivado' outlined dense></v-textarea>
            <h5>Error</h5>
            <v-textarea class='input-text' error messages='Este campo esta en estado de error' outlined dense></v-textarea>
            <h5>Success</h5>
            <v-textarea class='input-text' success messages='Este campo esta en estado de exito' outlined dense></v-textarea>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                someval: false,
                radioGroup: [true],
            }
        },
    }
</script>`" />

          <h2>Select</h2>
              <VueLive
              :code=
"`<template>
    <div class='flex-disp'>
        <div class='btns-cont'>
            <v-select class='input-text input-text--select' outlined dense></v-select>
            <h5>disabled</h5>
            <v-select class='input-text input-text--select' disabled outlined dense></v-select>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                someval: false,
                radioGroup: [true],
            }
        },
    }
</script>`" />

          <h2>Checkbox</h2>
              <VueLive
              :code=
"`<template>
    <div class='flex-disp'>
        <div class='btns-cont'>
            <v-checkbox dense label='Checkbox1' class='input-checkbox'></v-checkbox>
            <v-checkbox dense label='Checkbox2' class='input-checkbox'></v-checkbox>
            <h5>disabled</h5>
            <v-checkbox dense v-model='someval' label='Disabled' class='input-checkbox input-checkbox--disabled'></v-checkbox>
            <v-checkbox dense v-model='someval2' label='Disabled' class='input-checkbox input-checkbox--disabled'></v-checkbox>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                someval: false,
                someval2: true,
                radioGroup: [true],
            }
        },
    }
</script>`" />

            <h2>Switch</h2>
              <VueLive
              :code=
"`<template>
    <div class='flex-disp'>
        <div class='btns-cont'>
            <v-switch dense inset label='Disabled' class='input-switch' disabled></v-switch>
            <v-switch dense inset label='Switch 1' class='input-switch'></v-switch>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                someval: false,
                radioGroup: [true],
            }
        },
    }
</script>`" />

            <h2>Radio</h2>
              <VueLive
              :code=
"`<template>
    <div class='flex-disp'>
        <div class='btns-cont'>
            <v-radio-group v-model='radioGroup'>
              <v-radio on-icon='mdi-record-circle' class='input-radio' label='Radio1' value='a'></v-radio>
              <v-radio class='input-radio' on-icon='mdi-record-circle' label='Radio2' value='b'></v-radio>
            </v-radio-group>
            <h5>Disabled</h5>
            <v-radio-group v-model='someval'>
                  <v-radio class='input-radio input-radio--disabled' on-icon='mdi-record-circle' label='Disabled1' value='c'></v-radio>
                  <v-radio class='input-radio input-radio--disabled' on-icon='mdi-record-circle' label='Disabled2' value='c' v-model='someval'></v-radio>
            </v-radio-group>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                someval: false,
                radioGroup: [true],
            }
        },
    }
</script>`" />

            <h2>Slider</h2>
              <VueLive
              :code=
"`<template>
    <div class='flex-disp'>
        <div class='btns-cont'>
            <v-slider class='input-slider'></v-slider>
            <h5>disabled</h5>
            <v-slider value='60' class='input-slider input-slider--disabled'></v-slider>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                someval: false,
                radioGroup: [true],
            }
        },
    }
</script>`" />

          <h1> Table</h1>
          <VueLive
              :code=
"`<template>
    <div class='flex-disp'>
        <div class='btns-cont'>
              <v-data-table
              :headers='headers'
              :items='details'
              :items-per-page='itemsPerPage'
              :page.sync='page'
              @page-count='pageCount = $event'
              hide-default-footer
              class='table'
              >
                  <template #header.actions>
                      <div class='d-flex justify-end'>
                          <v-tooltip top>
                              <template v-slot:activator='{ on, attrs }'>
                                  <v-btn
                                      v-bind='attrs'
                                      v-on='on'
                                      class='btn-icon--primary btn-icon'
                                      align-self-end
                                      @click='alertconfig'
                                      ><v-icon>mdi-cog</v-icon></v-btn
                                  >
                              </template>
                              <span>Selecionar campos de la tabla</span>
                          </v-tooltip>
                      </div>
                  </template>
                  <template #item.actions='item'>
                      <div class='d-flex justify-end'>
                      <v-btn
                          class='btn-icon--primary btn-icon'
                          @click='alertedit(item.item.Name)'
                          ><v-icon>mdi-pencil</v-icon></v-btn
                      >
                      <v-btn
                          class='btn-icon--delete btn-icon ml-3'
                          @click='alertdelete(item.item.Name)'
                          ><v-icon>mdi-delete</v-icon></v-btn
                      >
                      </div>
                  </template>
              </v-data-table>
              <div class='text-center pt-2'>
                  <v-pagination
                      class='pagination'
                      v-model='page'
                      :length='pageCount'
                  ></v-pagination>
              </div>
          </div>
    </div>
</template>
<script>
      export default {
          data() {
              return {
                  page: 1,
            pageCount: 0,
            itemsPerPage: 5,
            headers:[
                {align:'center',sortable:true,text:'Name',value:'Name',},
                {align:'center',sortable:true,text:'Example Header2',value:'Header2',},
                {align:'center',sortable:true,text:'Example Header4',value:'Header4',},
                {align:'center',sortable:false,value:'actions',} // this header's content is modeled by a v-slot
            ],
            details:[
                {
                Name: 'Name 0.1',
                Header2: 'Example attr 0.2',
                //this next one will not be shown because its key is not asociated with any header's 'value'
                Header3: 'Example attr 0.3',
                //this item does not contain a 'Header4' key so it will not show in the table, (the cell will be empty)
                //the 'actions' for each item are modeled by a v-slot
                },
                {
                Name: 'Name 1.1',
                Header2: 'Example attr 1.2',
                //this item does not contain a 'Header4' key so it will not show in the table, (the cell will be empty)
                //the 'actions' for each item are modeled by a v-slot
                },
                {
                Name: 'Name 2.1',
                Header2: 'Example attr 2.2',
                Header4: 'Example attr 2.4',
                //the 'actions' for each item are modeled by a v-slot
                },
                {
                Name: 'Name 3.1',
                Header2: 'Example attr 3.2',
                Header4: 'Example attr 3.4',
                //the 'actions' for each item are modeled by a v-slot
                },
                {
                Name: 'Name 4.1',
                Header2: 'Example attr 4.2',
                Header4: 'Example attr 4.4',
                //the 'actions' for each item are modeled by a v-slot
                },
                {
                Name: 'Name 5.1',
                Header2: 'Example attr 5.2',
                Header4: 'Example attr 5.4',
                //the 'actions' for each item are modeled by a v-slot
                },
                {
                Name: 'Name 6.1',
                Header2: 'Example attr 6.2',
                Header4: 'Example attr 6.4',
                //the 'actions' for each item are modeled by a v-slot
                },

            ],
              }
          },
          methods:{
              alertconfig(){
                    alert('has abierto las configuraciones de la tabla')
                },
                alertedit(message){
                    alert('has editado el objeto: ', message, ' de la tabla' )
                },
                alertdelete(message){
                    alert('has borrado el objeto: ', message, ' de la tabla')
                },
          },
      }
</script>`" />
</div>
        <!--/div-->
    </main>
</drawer-layaout>
</template>

<script>
import Stepper from "../Shared/Stepper.vue"
import { VueLive } from "vue-live";
// import the css separately for easier SSR
import "vue-live/lib/vue-live.esm.css";
import SearchBar from "@/Shared/Demo/SearchBar"
import DrawerLayaout from "../Shared/DrawerLayout.vue";
import Notification from "../Shared/toast.vue";
import { mapActions, mapMutations } from 'vuex';
import Tabs from "../Shared/Tabs.vue";
export default {
    components:{ DrawerLayaout, Notification,VueLive, Tabs , SearchBar, Stepper,},
    data() {
        return {
            registeredStepper:{Stepper},
            registeredSearch:{SearchBar},
            registeredNotif:{ Notification},
            registeredTabs: { Tabs },

        }
    },
    methods:{
        logger(e){
            console.log(e);
        },
    }
}
</script>

<style>

</style>

